import { noop } from 'lodash';
import { useCallback, useState } from 'react';
import type { ApplicationRow, ApplicationStageActions } from './types';

export const applicationDrawers = {
  decision: 'decision',
  edit: 'edit',
  checklistReview: 'checklistReview',
  scheduleInterview: 'scheduleInterview',
  interviewResults: 'interviewResults',
  candidateDecision: 'candidateDecision',
  rejectCandidate: 'rejectCandidate',
  createOffer: 'createOffer',
  closeApplication: 'closeApplication',
} as const;

export type ApplicationDrawerName = (typeof applicationDrawers)[keyof typeof applicationDrawers];

const useApplicationActions = () => {
  const [openDrawer, setOpenDrawer] = useState<Nullable<ApplicationDrawerName>>(null);
  const [application, setApplication] = useState<Nullable<ApplicationRow>>(null);

  const getActions = useCallback((target: ApplicationRow): ApplicationStageActions => {
    const open = (drawer: ApplicationDrawerName) => () => {
      setApplication(target);
      setOpenDrawer(drawer);
    };

    return {
      startRejection: open(applicationDrawers.rejectCandidate),
      editApplication: open(applicationDrawers.edit),
      makeDecision: open(applicationDrawers.decision),
      reviewCompletedChecklist: open(applicationDrawers.checklistReview),
      scheduleInterview: open(applicationDrawers.scheduleInterview),
      provideInterviewResults: open(applicationDrawers.interviewResults),
      makeDecisionOnCandidate: open(applicationDrawers.candidateDecision),
      createOffer: open(applicationDrawers.createOffer),
      confirmChecklistSent: noop,
      confirmChecklistReceived: noop,
      calculatePercentile: noop,
      startCandidateQualification: noop,
      reviewOffer: noop,
      closeApplication: noop,
    };
  }, []);

  const onClose = useCallback(() => setOpenDrawer(null), []);

  return { getActions, drawerProps: { application, openDrawer, onClose } };
};

export default useApplicationActions;
